import { InjectionToken } from '@angular/core';

export type states = 'zw' | 'ls' | 'bi' | 'gh' | 'BW';

export enum STATES {
  ZIMBAMBWE = 'zw',
  LESOTHO = 'ls',
  BURUNDI = 'bi',
  GHANA = 'gh',
  BOTSWANA = 'BW'
}

export const STATE_MANAGEMENT_CONFIGURATION_TOKEN = new InjectionToken(
  'Configure State Management Module'
);
